import { gatewayUrl } from "config";
import axiosInstance from "utils/axios-request";

export enum NetBankingLinkType {
    URL = "url",
    HTML = "html",
}

export const getNetBankingLink = async (bankId: string, applicationId: number): Promise<{type: NetBankingLinkType, value: string }> => {
    const response = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: "/bs-service/netbanking-link",
        method: "get",
        params: {bankId, applicationId},
    });
    return response.data;
};
